/* KAMOK VOICE V2: move the sole existing recorder section under PDP media.
   Preserve the section's endpoint, permissions, consent and submission handling. */
(function(){
 'use strict';
 function place(){
   var slot=document.querySelector('[data-kamok-voice-slot]');
   var section=document.querySelector('section.kvoice[data-product-id]');
   if(!slot||!section)return;
   var wrapper=section.closest('.shopify-section')||section;
   if(wrapper===slot||slot.contains(wrapper))return;
   if(!wrapper.parentElement)return;
   slot.appendChild(wrapper);
   slot.setAttribute('data-kamok-voice-ready','');
   var mic=section.querySelector('.kvmic');
   if(mic&&!mic.dataset.kamokCompactBound){
      mic.dataset.kamokCompactBound='1';
      mic.addEventListener('click',function(){slot.setAttribute('data-kamok-voice-expanded','');});
   }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',place,{once:true});else place();
 document.addEventListener('shopify:section:load',place);
})();
